import { ReactNode } from 'react'
import Navbar from '../components/sections/navigation/public/Navbar'
import Footer from '../components/sections/navigation/public/Footer'

interface PublicPageLayout {
    children: ReactNode
}
export default function PublicPageLayout({ children }: PublicPageLayout) {
    return (
        <div>
            <Navbar />
            <div className="min-h-screen bg-[#F8FAFC] text-slate-800 font-sans pb-12">
                {children}

            </div>
            <Footer />
        </div>
    )
}
